import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/home/runner/work/nextjs-asktraining.com.sg/nextjs-asktraining.com.sg/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.js");
